import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ClearIcon from "@mui/icons-material/Clear";

import { formatDate } from "../../../utils/formatDate";
import { HeaderDatePicker } from "./HeaderDatePicker";

import {
  setVolumeOverlayDate,
  setShowErrorModal,
  setDefaultOverlayData,
} from "../../../reducers/app";

import { volumeOverlayDateSelector } from "../../../reducers/app/selector";
import "../Header.css";

export const VolumeOverlay = ({ activeDropDown, setActiveDropDown }) => {
  const dispatch = useDispatch();
  const overlayDate = useSelector(volumeOverlayDateSelector);

  return (
    <div
      className="headerSegment"
      onClick={(e) => {
        e.stopPropagation();
        if (activeDropDown === "volume") {
          setActiveDropDown("none");
        } else {
          dispatch(setShowErrorModal(false));
          setActiveDropDown("volume");
        }
      }}
    >
      Volume Overlay:
      {overlayDate === null ? (
        <span>None selected</span>
      ) : (
        <div className="headerSegment">
          {formatDate(overlayDate, "DD/MM/YYYY")}
          <ClearIcon
            className="headerIcon"
            onClick={() => {
              dispatch(setVolumeOverlayDate(null));
              dispatch(setDefaultOverlayData([]));
              setActiveDropDown("none");
            }}
          />
        </div>
      )}
      <ChevronRightIcon
        className={`headerIcon ${
          activeDropDown === "volume"
            ? "headerChevronIconOpen"
            : "headerChevronIcon"
        }`}
      />
      {activeDropDown === "volume" && (
        <HeaderDatePicker
          activeDropDown={activeDropDown}
          setActiveDropDown={setActiveDropDown}
        />
      )}
    </div>
  );
};
